import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import { Subject } from "rxjs/Subject";

@Injectable()
export class LeafletService {
  private _layerControl: any;
  private _L: any;
  private _map: any;
  private imgLayer;
  private imgAnnLayer;
  private imgGroup;

  private _drawnFeauresLayer: any;
  private _drawControl: any;

  private _queryBounds: Subject<any>;

  private drawControl;

  constructor() {
    this._L = L;

    // 影像地图
    this.imgLayer = L.tileLayer.chinaProvider("TianDiTu.Satellite.Map", {});
    this.imgAnnLayer = L.tileLayer.chinaProvider(
      "TianDiTu.Satellite.Annotion",
      {}
    );
    this.imgGroup = L.layerGroup([this.imgLayer, this.imgAnnLayer]);
    this._queryBounds = new Subject<any>();

    this._drawnFeauresLayer = new L.FeatureGroup();
    console.log("leafletservice init");
  }


   /**
   * 将queryBounds(查询范围)设置为可观察对象，订阅该变量实时获取查询范围
   */
  get queryBounds() {
    return this._queryBounds.asObservable();
  }


  /**
   * @prop {L.map} map 地图
   */
  get map() {
    return this._map;
  }

  public get layerControl() {
    return this._layerControl;
  }

  /**
   *
   *
   * @param {HTMLElement} container
   * @param {object} [leafletOptions]
   * @param {object} [leafletLayersControl]
   * @memberof LeafletService
   */
  init(
    container: HTMLElement,
    leafletOptions?: any,
    leafletLayersControl?: any
  ) {
    this._map = this._L.map(container, leafletOptions);


    window["map"] = this._map;
    // 矢量地图
    const vectorMap = L.tileLayer.chinaProvider("TianDiTu.Normal.Map", {
      maxZoom: 18
    });
    const vectorAnn = L.tileLayer.chinaProvider("TianDiTu.Normal.Annotion", {});
    const vecGroup = L.layerGroup([vectorMap, vectorAnn]);

    // 地形地图
    const terrainMap = L.tileLayer.chinaProvider("TianDiTu.Terrain.Map", {});
    const terrainAnn = L.tileLayer.chinaProvider(
      "TianDiTu.Terrain.Annotion",
      {}
    );
    const terrainGroup = L.layerGroup([terrainMap, terrainAnn]);

    const osm = L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    );

    const layers = {
      baseLayers: {
        OSM矢量地图: osm,
        矢量地图: vecGroup,
        // 影像地图: this.imgGroup,
        // 地形地图: terrainGroup
      },
      overlays: {}
    };

    if (leafletOptions.layersControl) {
      this._layerControl = this._L.control
        .layers(layers.baseLayers, layers.overlays, { collapsed: true })
        .addTo(this._map);
      window["map"] = this._map;
      window["layerctl"] = this._layerControl;
    }
    if (leafletOptions.baseLayer) {
      this.imgGroup.addTo(this._map);
    }
    if (leafletOptions.measureCtl) {
      L.control
        .measure({
          position: "topleft",
          primaryLengthUnit: "meters",
          secondaryLengthUnit: undefined,
          primaryAreaUnit: "sqmeters",
          secondaryAreaUnit: undefined,
          activeColor: "#08316F",
          completedColor: "#08316F",
          localization: "cn"
        })
        .addTo(this._map);
    }

    // 初始化地图事件(随UI变化地图更新)
    const that = this;
    this._map.whenReady(() => {
      setTimeout(() => {
        that._map.invalidateSize(true);
      });
      that._map.on("resize", e => {
        that._map.invalidateSize(true);
        console.log("map resize");
      });

      that._map.on("viewreset", e => {
        that._map.invalidateSize(true);
        console.log("map view reset");
      });
    });


    this.initDraw();
    this.addZoomCtrl();
  }

  createWmsLayer(url, layerName) {
    return L.tileLayer.wms(url, {
      layers: layerName,
      format: "image/png",
      transparent: true
    });
  }

  addOverlay(layer: any, layerName: string) {
    this._layerControl.addOverlay(layer, layerName);
  }

  zoomToExtent(extent: any) {
    this._map.flyToBounds(extent, { animate: false });
  }

  getBaseImg() {
    return this.imgLayer;
  }

  getLayerBounds(layer: any) {
    return layer.getBounds();
  }

  setCenter(latlng) {
    this._map.setView(latlng, 14);
  }

  getImgGroup() {
    return this.imgGroup;
  }

  getBaseLayers() {
    // 影像地图
    const imgLayer = L.tileLayer.chinaProvider("TianDiTu.Satellite.Map", {});
    const imgAnnLayer = L.tileLayer.chinaProvider(
      "TianDiTu.Satellite.Annotion",
      {}
    );
    const imgGroup = L.layerGroup([this.imgLayer, this.imgAnnLayer]);

    const vectorMap = L.tileLayer.chinaProvider("TianDiTu.Normal.Map", {
      maxZoom: 18
    });
    const vectorAnn = L.tileLayer.chinaProvider("TianDiTu.Normal.Annotion", {});
    const vecGroup = L.layerGroup([vectorMap, vectorAnn]);

    // 地形地图
    const terrainMap = L.tileLayer.chinaProvider("TianDiTu.Terrain.Map", {});
    const terrainAnn = L.tileLayer.chinaProvider(
      "TianDiTu.Terrain.Annotion",
      {}
    );
    const terrainGroup = L.layerGroup([terrainMap, terrainAnn]);

    const osm = L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    );

    const layers = {
      baseLayers: {
        OSM矢量地图: osm,
        矢量地图: vecGroup,
        影像地图: this.imgGroup,
        地形地图: terrainGroup
      },
      overlays: {}
    };
  }

  removeLayer(layer:any)
  {
    this._map.removeLayer(layer);
  }

  get drawFeatureLayer() {
    return this._drawnFeauresLayer;
  }



  addZoomCtrl() {
    //放大缩小按钮
    L.control
      .zoom({
        zoomInTitle: "放大",
        zoomOutTitle: "缩小",
        position: "bottomright"
      })
      .addTo(this._map);
  }

    /**
   * 发射当前最新查询范围
   */
  setQueryBounds(value) {
    this._queryBounds.next(value);
  }

  initDraw() {
    // 初始化DrawControl
    //绘制框，编辑和删除
    this.drawControl = new L.Control.Draw({
      draw: {
        polygon: true,
        marker: false,
        circle: false,
        polyline: false,
        rectangle: true,
        circlemarker: false
      },
      edit: {
        featureGroup: this._drawnFeauresLayer,
        edit: true
      },
      delete: {
        removeAllLayers: false
      },
      position: "bottomright"
    });



    this._map.addControl(this.drawControl);
    this._map.addLayer(this._drawnFeauresLayer);

    // 开始绘制监听事件，清除上一次绘制的图形
    this._map.on("draw:drawstart", e => {
      this._drawnFeauresLayer.clearLayers();
      this.setQueryBounds(null);
    });

    // 创建查询矩形
    this._map.on("draw:created", e => {
      const type = e.layerType,
        layer = e.layer;
      this._drawnFeauresLayer.addLayer(layer);
      console.log(layer.getBounds());
      const bounds = layer.getBounds(),
        south = bounds.getSouth().toFixed(4),
        east = bounds.getEast().toFixed(4),
        west = bounds.getWest().toFixed(4),
        north = bounds.getNorth().toFixed(4);
      this.setQueryBounds({ east, west, south, north });
    });

    this._map.on("draw:edited", e => {
      console.log("draw:edited");
    });
  }


  removeDrawCtrol(){
    this._map.removeControl(this.drawControl);
  }


  createHeatLayer() {
    return L.heatLayer([], { radius: 25 });
  }

  createMarkerClusterLayer() {
    return L.markerClusterGroup();
  }

  refresh() {
    setTimeout(() => {
      this._map.invalidateSize();
    }, 500);
  }

}
